<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.patients', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @reset="onReset" v-if="show">
                    <b-container>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="lastName-group"
                                        :label="$t('message.lastName')"
                                        label-for="lastName"
                                        description=""
                                >
                                    <b-form-input
                                            id="lastName"
                                            v-model="$v.form.user.nom.$model"
                                            :state="$v.form.user.nom.$dirty ? !(errorshasField('nom') || $v.form.user.nom.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('nom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.user.nom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                        {{ getErrorsField('nom') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="firstName-group"
                                        :label="$t('message.firstName')"
                                        label-for="firstName"
                                        description=""
                                >
                                    <b-form-input
                                            id="firstName"
                                            v-model="$v.form.user.prenom.$model"
                                            :state="$v.form.user.prenom.$dirty ? !(errorshasField('prenom') || $v.form.user.prenom.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('prenom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.user.prenom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('prenom')">
                                        {{ getErrorsField('prenom') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>
                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="telephone-group"
                                        :label="$t('message.phoneNumber')"
                                        label-for="telephone"
                                >
                                    <b-form-input
                                            id="telephone"
                                            v-model="$v.form.user.telephone.$model"
                                            :state="$v.form.user.telephone.$dirty ? !(errorshasField('telephone') || $v.form.user.telephone.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('telephone')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.user.telephone.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="!$v.form.user.telephone.minLength">
                                        {{ $t('message.minCharacters', { n: 9 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="!$v.form.user.telephone.integer">
                                        {{ $t('message.integer', { n: 9 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('telephone')">
                                        {{ getErrorsField('telephone') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">
                                <b-form-group
                                        id="email-group"
                                        :label="$t('message.email')"
                                        label-for="email"
                                >
                                    <b-form-input
                                            id="email"
                                            v-model="$v.form.user.email.$model"
                                            :state="$v.form.user.email.$dirty ? !(errorshasField('email') || $v.form.user.email.$error) : null"
                                            type="email"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('email')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.user.email.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.email.email">
                                        {{ $t('message.emailNotValid') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                        {{ getErrorsField('email') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="sexe-group"
                                        :label="$t('message.gender')"
                                        label-for="gender">
                                    <b-form-select
                                            id="gender"
                                            v-model="form.sexe"
                                            :state="$v.form.sexe.$dirty ? !(errorshasField('sexe') || $v.form.sexe.$error) : null"
                                            :options="sexes"
                                            required
                                            @focus="clearErrorField('sexe')"
                                    ></b-form-select>

                                    <b-form-invalid-feedback v-if="!$v.form.sexe.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('sexe')">
                                        {{ getErrorsField('sexe') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <i class="fas fa-question float-right" id="popover-target-1"></i>
                                <b-popover target="popover-target-1" triggers="hover" placement="top">
                                    <template v-slot:title>{{$t('message.unknownDate')}}</template>
                                    {{$t('message.unknownDateText')}}
                                </b-popover>
                                <b-form-group
                                        id="dob-group"
                                        :label="$t('message.dob')"
                                        label-for="dob">
                                    <b-form-input
                                            id="dob"
                                            v-model="form.date_de_naissance"
                                            type="date"
                                            placeholder=""
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.date_de_naissance.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('date_de_naissance')">
                                        {{ getErrorsField('date_de_naissance') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="nationalite-group"
                                        :label="$t('message.nationality')"
                                        label-for="nationalite"
                                >
                                    <b-form-input
                                            id="nationalite"
                                            v-model="form.user.nationalite"
                                            :state="$v.form.user.nationalite.$dirty ? !(errorshasField('nationalite') || $v.form.user.nationalite.$error) : null"
                                            @focus="clearErrorField('nationalite')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('nationalite')">
                                        {{ getErrorsField('nationalite') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.nationalite.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="singleAddPatient-group"
                                        :label="$t('message.select')+' '+$tc('message.countries', 1)"
                                        label-for="singleAddPatient">
                                    <!-- Options -->
                                    <select id="singleAddPatient"  v-model="$v.form.user.pays.$model" required @focus="clearErrorField('pays')">
                                        <option v-for="item in mCountries" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="errorshasField('pays')">
                                        {{ getErrorsField('pays') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.pays.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="ville-group"
                                        :label="$tc('message.cities', 1)"
                                        label-for="ville"
                                >
                                    <b-form-input
                                            id="ville"
                                            v-model="form.user.ville"
                                            :state="$v.form.user.ville.$dirty ? !(errorshasField('ville') || $v.form.user.ville.$error) : null"
                                            @focus="clearErrorField('ville')"
                                            required
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('ville')">
                                        {{ getErrorsField('ville') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.ville.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="street-group"
                                        :label="$t('message.street')"
                                        label-for="street"
                                >
                                    <b-form-input
                                            id="street"
                                            v-model="form.user.quartier"
                                            :state="$v.form.user.quartier.$dirty ? !(errorshasField('quartier') || $v.form.user.quartier.$error) : null"
                                            @focus="clearErrorField('quartier')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('quartier')">
                                        {{ getErrorsField('quartier') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="zipCode-group"
                                        :label="$t('message.zipCode')"
                                        label-for="zipCode"
                                >
                                    <b-form-input
                                            id="zipCode"
                                            v-model="form.user.code_postal"
                                            :state="$v.form.user.code_postal.$dirty ? !(errorshasField('code_postal') || $v.form.user.code_postal.$error) : null"
                                            @focus="clearErrorField('code_postal')"
                                            type="number"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('code_postal')">
                                        {{ getErrorsField('code_postal') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="address-group"
                                        :label="$t('message.address')"
                                        label-for="address"
                                >
                                    <b-form-input
                                            id="address"
                                            v-model="$v.form.user.adresse.$model"
                                            :state="$v.form.user.adresse.$dirty ? !(errorshasField('adresse') || $v.form.user.adresse.$error) : null"
                                            @focus="clearErrorField('adresse')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('adresse')">
                                        {{ getErrorsField('adresse') }}
                                    </b-form-invalid-feedback>

                                    <!--                                    <b-form-invalid-feedback v-else-if="!$v.form.user.adresse.required">-->
                                    <!--                                        {{ $t('message.requiredField') }}-->
                                    <!--                                    </b-form-invalid-feedback>-->

                                </b-form-group>

                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col sm="12">
                                <div>
                                    <label class="form__label" for="hasDesc2">{{$t('message.isMedPatner')}}</label>
                                    <div class="toggle">
                                        <input id="hasDesc2" type="checkbox" v-model="form.user.isMedicasure"/>
                                        <label for="hasDesc2">
                                            <div class="toggle__switch"></div>
                                        </label>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>

                        <b-col sm="12" v-if="form.user.isMedicasure">
                            <b-row class="mb-2">
                                <b-col sm="6">
                                    <span>Souscripteur: <strong>{{item.text}}</strong></span>
                                </b-col>
                                <b-col sm="6">
                                    <button  type="button" class=" btn btn-danger btn-sm" @click="clearSouscripteur">Supprimer</button>
                                </b-col>
                            </b-row>

                            <div class="vgt-global-search vgt-clearfix">

                                <div class="vgt-global-search__input vgt-pull-left"><span class="input__icon">
                                        <div class="magnifying-glass">

                                        </div>
                                    </span>
                                    <input type="text" placeholder="Search user" class="vgt-input vgt-pull-left" v-model="searchTerm">
                                </div>
                                <div class="vgt-global-search__actions vgt-pull-right">

                                </div>
                            </div>
                            <vue-good-table
                                    id="operation"
                                    :columns="mSubscribersColumns"
                                    :rows="mSubscribersFilter"
                                    :search-options="{
                                        enabled:true,
                                        externalQuery: searchTerm
                                        }"
                                    :pagination-options="paginationOptions"
                                    @on-row-click="onSubscriberClick"
                            />
                            <span v-if="errorshasField('souscripteur_id')" style="color: red">
                                    {{ getErrorsField('souscripteur_id') }}
                                </span>
                            <br>
                        </b-col>
                    </b-container>

                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <p class="alert-warning" v-if="$v.form.user.telephone.$model != oldPhone || $v.form.date_de_naissance.$model != oldDate">
                                {{$t('message.shallBeGenerate')}} {{form.user.smsEnvoye}} {{$t('message.alreadySend')}}
                            </p><br>

                        </b-row>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button  @click="onSubmit" variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>
                            <!--                            <b-button type="reset" variant="danger">-->
                            <!--                                {{ $t('message.reset') }}-->
                            <!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, email, minLength, integer } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';

    export default {
        name: "EditPatient",

        computed: {
            ...mapGetters(["patient", "countries", "subscribers", "errors",'hasAdminRole',
                'hasGestionnaireRole','hasMedecinControleRole','hasPraticienRole',"questions",
            'hasAssistante']),

            userIsMed:function(){
                return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
            },

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            form: function() {
                let self = this;
                if (!_.isUndefined(this.patient.souscripteur)){
                    if (!_.isNull(this.patient.souscripteur)){
                        if (!_.isUndefined(this.patient.souscripteur.user)) {
                            let user = this.patient.souscripteur.user;
                            let prenom = user.prenom != null ? user.prenom : "";
                            prenom = prenom.toLowerCase();
                            let fullName = (user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                            self.item = {text: fullName, value: user.id}
                        }
                    }
                }
                let patient = this.patient;

                return patient;
            },

            mQuestions: function() {
                let qArray = [];

                _.forOwn(this.questions, function(value, key) {
                    qArray.push({ text: value.intitule, value: value.id });
                });

                return qArray;
            },
            mCountries: function() {
                let cArray = [];

                _.forOwn(this.countries, function(value, key) {
                    cArray.push({ text: value.name, value: value.name });
                });

                return cArray;
            },

            mSubscribers: function() {
                let sArray = [];

                _.forOwn(this.subscribers, function(value, key) {
                    if(!_.isNull(value.user)){
                        let prenom  = value.user.prenom != null ? value.user.prenom : "";
                        prenom =  prenom.toLowerCase();
                        let fullName = (value.user.nom).toUpperCase()+ " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        sArray.push({ text: fullName, value: value.user.id });
                    }
                });

                return sArray;
            },
        },

        data() {
            return {
                oldPhone:'',
                oldDate:'',
                item:{text:'Selectionner un souscripteur ci-dessous',value:0},
                mSubscribersColumns: [
                    {
                        field: 'text',
                        label: this.$i18n.t('message.name'),
                    },
                ],
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                mSubscribersFilter:[],
                searchTerm : '',
                patient_id: this.$route.params.patient,
                show: true,
                sexes: [
                    { value: 'F', text: this.$i18n.t('message.female') },
                    { value: 'M', text: this.$i18n.t('message.male') }
                ]
            }
        },
        watch:{
            searchTerm:function (newValue, oldValue) {
                if (!this.hasPatientRole){
                    if (newValue.trim().length ==0){
                        this.mSubscribersFilter = [];
                    }else{
                        this.mSubscribersFilter = this.mSubscribers;
                    }
                }else{
                    this.mSubscribersFilter =this.mSubscribers;
                }
            }
        },

        created() {
            this.oldPhone = this.patient.user.telephone;

            this.oldDate = this.patient.date_de_naissance;
        },

        methods: {
            getQuestionsList() {
                let args = {
                };

                this.$store.dispatch('getQuestions', { args : args });
            },

            clearSouscripteur(){
                this.item = {};
            },
            onSubscriberClick(params){
                // this.$router.push({ name: 'patient', params: { patient: params.row.value } });
                this.item = {text:params.row.text,value:params.row.value};
                this.searchTerm = '';
            },

            getPatient: function() {
                let args = {
                    patient: this.patient_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getPatient', { args, errorMessages });
            },

            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },

            getSubscribers: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getSubscribers', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();
                //Définition du souscripteur du patient
                let sous = '0';
                if (this.userIsMed == '1'){
                    // if (this.isMed == '1'){
                    sous = this.item.value;
                    // }
                }

                if(!this.$v.$invalid) {
                    let args = {
                        patient: this.patient_id,
                        nom: this.form.user.nom,
                        prenom: this.form.user.prenom,
                        adresse: this.form.user.adresse,
                        // souscripteur_id: this.item.value,
                        email: this.form.user.email,
                        telephone: this.form.user.telephone,
                        sexe: this.form.sexe,
                        date_de_naissance: this.form.date_de_naissance,
                        nationalite: this.form.user.nationalite,
                        ville: this.form.user.ville,
                        pays: this.form.user.pays,
                        quartier: this.form.user.quartier,
                        code_postal: this.form.user.code_postal,
                        isMedicasure: this.form.user.isMedicasure ? '1' :'0',
                    };

                    if (sous != '0'){
                        args['souscripteur_id'] = sous;
                    }

                    let successMessage = this.$i18n.t('message.patientUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updatePatient', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.user.nom = '';
                this.form.user.email = '';
                this.form.user.telephone = '';
                this.form.souscripteur.sexe = 'F';
                this.form.souscripteur.date_de_naissance = null;
                this.form.user.nationalite = '';
                this.form.user.ville = '';
                this.form.user.pays = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {

            form: {
                user: {

                    isMedicasure: {

                    },

                    quartier:{

                    },
                    code_postal:{

                    },
                    nom: {
                        required
                    },

                    adresse: {
                        // required
                    },

                    prenom: {
                        //
                    },

                    telephone: {
                        integer,
                        required,
                        minLength: minLength(9)
                    },
                    email: {
                        // required,
                        email
                    },
                    nationalite: {
                        // required
                    },
                    ville: {
                        required
                    },
                    pays: {
                        required
                    },


                },
                date_de_naissance: {
                    required
                },
                sexe: {
                    required
                },
                souscripteur_id: {
                    // required
                },
            }
        },

        mounted() {
            // Retrieve patient
            this.getPatient();

            // Retrieve list of countries
            this.getCountries();

            // Retrieve list of subscribers
            this.getSubscribers();

            // Retrieve list of question
            this.getQuestionsList();

            new SlimSelect({
                select: '#singleAddPatient',
                placeholder: 'Select country'
            }) ;

            new SlimSelect({
                select: '#souscripteur',
                placeholder: 'Select subscriber'
            });

            new SlimSelect({
                select: '#question',
                placeholder: 'Select secret question'
            }) ;
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>